import { TakeOverWatch } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const TAKE_OVER_WATCH_DATA_TAG = 'TakeOverWatch';
export default class TakeOverWatchParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.TAKE_OVER_WATCH, FIXED_PROTOCOL_CONTENT_TYPE_IDS.TAKE_OVER_WATCH, TAKE_OVER_WATCH_DATA_TAG, app);
    }
    getPropsMapping() {
        return {
            takeOverWatchFrom: 'takeOverWatchFrom',
            authorRole: 'authorRole',
            oow: 'oow',
            lookout: 'lookout',
            helmsman: 'helmsman',
            freeText: 'freeText',
        };
    }
    createData(props) {
        return new TakeOverWatch(props.takeOverWatchFrom, props.authorRole, props.oow, props.lookout, props.helmsman, props.freeText);
    }
}
//# sourceMappingURL=TakeOverWatchParser.js.map